// extracted by mini-css-extract-plugin
module.exports = {"tips":"index_tips__X3ZT3"};